import { Box, Text } from '@src/shared/ui';

export const AlertProposal = () => {
  return (
    <Box className='col-span-8 md:col-start-8 md:col-span-5 bg-alert-10 mt-8 sm:mt-12 hidden sm:flex text-left px-6 py-4 rounded-2xl flex-row items-start gap-3'>
      <Box>
        <img
          src='/alert-circle.svg'
          className='max-w-[24px] min-w-[24px] min-h-[24px] max-h-[24px]'
          alt='Ícone de alerta'
        />
      </Box>
      <Text className='text-neutral-70 font-normal text-base'>
        Para saber mais detalhes sobre a sua viagem, entre em contato com a GOL
        Linhas Aéreas.
      </Text>
    </Box>
  );
};
